import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import "style/globals.scss";

import { StrictMode } from "react";
import { I18nextProvider } from "react-i18next";

import i18next from "lib/i18n/config";

import { App } from "app/app";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [Sentry.browserTracingIntegration()],
  sampleRate: 0.05,
  tracesSampleRate: 0.05,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

const rootElement = document.getElementById("app");
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </StrictMode>
);
